import { Text, Group, Badge, ThemeIcon, BadgeProps } from "@mantine/core";
import { IconMessages } from "@tabler/icons-react";
import useCountTotalComentariosPerIdeia from "@/modules/ideia-comentarios/hooks/useCountTotalComentariosPerIdeia";

const TotalComentariosBadge = ({ ideia, ...badgeProperties }: BadgeProps & { ideia: TIdeia }) => {
  const { data: totalComentariosNaIdeia } = useCountTotalComentariosPerIdeia(ideia);

  return (
    <Group align="center" gap="xs">
      <Badge
        color="gray.2"
        py="md"
        px="sm"
        radius="md"
        style={{ minHeight: "32px", display: "flex", alignItems: "center" }}
        leftSection={
          <ThemeIcon variant="light" size="sm" bg="transparent">
            <IconMessages />
          </ThemeIcon>
        }
        {...badgeProperties}
      >
        <Text c="dark" fz="xs" fw={500} tt="lowercase" style={{ lineHeight: 1.4 }}>
          {totalComentariosNaIdeia} comentários
        </Text>
      </Badge>
    </Group>
  );
};

export default TotalComentariosBadge;
